/**
 * 404 Not Found page.
 */
export function NotFoundPage() {
  return (
    <div className="not-found-page">
      <h1>404</h1>
      <p>La pagina richiesta non esiste.</p>
      <a href="/" className="btn btn-primary">Torna alla home</a>
    </div>
  );
}
